<template>
  <div>
    <SectionTitle has-line content="Listado de Artículos" />

    <div class="row bg--gray mx-0">
      <div class="col-12 col-md-9 pr-md-0">
        <filter-manager
          v-model="this.filterModel"
          :filters="filtersHeader"
          :display-advanced="false"
          @search="onSearch"
        />
      </div>
      <div v-if="!addArticle" class="col-12 col-md-3 pl-0 addArticlePanel">
        <div class="p-3 mb-2">
          <ActionButton
            variant="ab-btn ab-btn-outline-success my-1 col-sm"
            i="fas fa-file-plus"
            @click="onOpenClose"
          >
            Añadir artículo
          </ActionButton>
        </div>
      </div>
    </div>

    <div v-if="addArticle">
      <article-add
        @onClose="onOpenClose"
        @onSaveArticle="(articleName) => onAdd(articleName)"
      />
    </div>

    <CustomResultNotFound
      v-if="itemsList.length == 0"
      class="mt-4 row pt-3"
      text="No cuenta información disponible."
    />

    <article-row
      v-for="item in itemsList"
      :key="`row-item-${item.id}`"
      ref="articleRow"
      class="mb-2 mt-2"
      :value="item"
      @onDelete="(article) => onDelete(article)"
      @onEdit="(article) => onEdit(article)"
    />
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import FilterManager from 'FilterManager';
import ArticleRow from './ArticleRow';
import ArticleAdd from './ArticleAdd';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';

export default {
  name: 'ArticlesList',
  components: {
    SectionTitle,
    FilterManager,
    CustomResultNotFound,
    ActionButton,
    ArticleRow,
    ArticleAdd,
  },
  props: {
    itemsList: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    addArticle: false,
    filterModel: {
      articleName: null,
    },
  }),
  computed: {
    filtersHeader() {
      return [
        {
          name: 'articleName',
          component: 'CustomInput',
          placeholder: 'Escribir aquí para buscar',
          value: this.filterModel.articleName,
          class: 'col-12 d-flex flex-column',
          type: 'text',
        },
      ];
    },
  },
  methods: {
    onOpenClose() {
      this.addArticle = !this.addArticle;
    },
    onSearch() {
      this.$emit('onSearch', this.filterModel.articleName);
    },
    onAdd(articleName) {
      this.$emit('onAdd', articleName, this.filterModel.articleName);
      this.onOpenClose();
    },
    onEdit(article) {
      this.$emit('onEdit', article, this.filterModel.articleName);
    },
    onDelete(article) {
      this.$emit('onDelete', article, this.filterModel.articleName);
    },
  },
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 768px) {
  .addArticlePanel div {
    margin-left: 1rem;
  }
}
</style>
